<div class="modal-header">
    <button type="button" class="btn-close btn-sm" aria-label="Close" (click)="close()"></button>
</div>
<div class="modal-body">
    <div class="col-md-12 d-flex justify-content-center">
        <label class="Label1 spacing-label">
            <div class="row no-gutters cursor-pointer">
                <div class="col-2">
                    <img *ngIf="InputData.Photo != null && InputData.Photo!= ''" mat-card-image class="userImage"
                        [src]="InputData.Photo" />
                    <div *ngIf="InputData.Photo == null || InputData.Photo == ''" class="initial-image">
                        <div class="image">
                            {{InputData.FullName}}
                        </div>
                    </div>
                </div>
                <span class="text-label-light">#{{InputData.EmpCode}}</span>
            </div>
        </label>
    </div>
    <div class="row" style="margin-top: 3px;">
        <div class="col-md mx-1 px-1 bghighlight">
            <div class="row">
                <div class="text-label">Full Name</div>
            </div>
            <div class="row text-right">
                <div>{{InputData.EmpName}}</div>
            </div>
        </div>
    </div>
    <div class="row" style="margin-top: 3px;">
        <div class="col-md mx-1 px-1 bghighlight">
            <div class="row">
                <div class="text-label">Designation</div>
            </div>
            <div class="row text-right">
                <div>{{InputData.DesignationName}}</div>
            </div>
        </div>
        <div class="col-md mx-1 px-1 bghighlight">
            <div class="row">
                <div class="text-label">Email</div>
            </div>
            <div class="row text-right">
                <div>{{InputData.Email}}</div>
            </div>
        </div>
        <div class="col-md mx-1 px-1 bghighlight">
            <div class="row">
                <div class="text-label">Contact No</div>
            </div>
            <div class="row text-right">
                <div>{{InputData.Contact}}</div>
            </div>
        </div>
    </div>
    <div class="row" style="margin-top: 3px;">
        <div class="col-md mx-1 px-1 bghighlight">
            <div class="row">
                <div class="text-label">Branch Name</div>
            </div>
            <div class="row text-right">
                <div>{{InputData.BranchName}}</div>
            </div>
        </div>
        <div class="col-md mx-1 px-1 bghighlight">
            <div class="row">
                <div class="text-label">Reporting Person</div>
            </div>
            <div class="row text-right">
                <div>{{InputData.ReportingPersonName}}</div>
            </div>
        </div>
        <div class="col-md mx-1 px-1 bghighlight">
            <div class="row">
                <div class="text-label">Birth Date</div>
            </div>
            <div class="row text-right">
                <div>{{InputData.BirthDate}}</div>
            </div>
        </div>
    </div>
    <div class="row" style="margin-top: 3px;">
        <div class="col-md mx-1 px-1 bghighlight">
            <div class="row">
                <div class="text-label">Date Of Joining</div>
            </div>
            <div class="row text-right">
                <div>{{InputData.DateofJoining}}</div>
            </div>
        </div>
        <div class="col-md mx-1 px-1 bghighlight">
            <div class="row">
                <div class="text-label">Confirmed Date</div>
            </div>
            <div class="row text-right">
                <div>{{InputData.DateOfConfirmation}}</div>
            </div>
        </div>
        <div class="col-md mx-1 px-1 bghighlight">
            <div class="row">
                <div class="text-label">Total Work Experience</div>
            </div>
            <div class="row text-right">
                <div>{{InputData.TotalWorkExperience}}</div>
            </div>
        </div>
    </div>
</div>